
import * as React from 'react';

function SvgCalendarWorkCalendar(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
            <rect width="17" height="16" x="3" y="4" rx="2" ry="2" />

            <line x1="16" x2="16" y1="2" y2="6" />
            <line x1="8" x2="8" y1="2" y2="6" />

            <line x1="3" x2="20" y1="9" y2="9" />

            <rect width="1.5" height="1.5" x="6.5" y="11.5" rx="0.2" fill="currentColor" stroke="none" />
        </svg>

    );
}

export default SvgCalendarWorkCalendar;
